import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

const resources = {
  en: { translation: require('./locales/en.json') },                          // 英文,
  fr: { translation: require('./locales/fr.json') },                          // 法语,
  ge: { translation: require('./locales/ge.json') },                          // 德语,
  it: { translation: require('./locales/it.json') },                          // 意大利语,
  sp: { translation: require('./locales/sp.json') },                          // 西班牙语,
  dut: { translation: require('./locales/dut.json') },                        // 荷兰语,
  in: { translation: require('./locales/in.json') },                          // 印地语,
  sv: { translation: require('./locales/se.json') },                          // 瑞典语,
  ja: { translation: require('./locales/jp.json') },                          // 日语,
  zh: { translation: require('./locales/zh.json') },                          // 中文简体,
  zh_hant: { translation: require('./locales/zh-hant.json') },                // 中文繁体,
  cs: { translation: require('./locales/cs.json') },                          // 捷克语,
  da: { translation: require('./locales/da.json') },                          // 丹麦语,
  fi: { translation: require('./locales/fi.json') },                          // 芬兰文,
  ko: { translation: require('./locales/ko.json') },                          // 韩语,
  nb: { translation: require('./locales/nb.json') },                          // 挪威语,
  pl: { translation: require('./locales/pl.json') },                          // 波兰语,
  pt: { translation: require('./locales/pt.json') },                          // 葡萄牙语,
  pt_BR: { translation: require('./locales/pt-BR.json') },                    // 葡萄牙语（巴西）,
  th: { translation: require('./locales/th.json') },                          // 泰语,
  tr: { translation: require('./locales/tr.json') },                          // 土耳其语,
};

// 获取localStorage中的语言设置
var language = window.language;

if (!language) {
  // const lang = (navigator.languages && navigator.languages[0]) || navigator.language; // 获取浏览器语言
  // language = lang.split('-')[0]; // 语言（简写）
  //暂时默认加载EN
  language = 'en'
}

i18n.use(initReactI18next)
  .init({
    resources,
    lng: language,
    nsSeparator: false, // key的空间分割，不分割
    keySeparator: false,// key的分割字符 不分割
    fallbackLng: 'en', // resources中匹配不到时的语言
    interpolation: {
      escapeValue: false,
    }
  });

var Words = function (key, v1, v2, v3, v4) {

  // 不传入变量
  return i18n.t(key, { v1, v2, v3, v4 }); // 调取语言包，翻译
}

export default Words;